import { createLucideIcon } from 'lucide-react';
export const SmsIcon = createLucideIcon('sms-icon', [
  [
    'path',
    {
      d: 'M21 4V15.5996H10.248L9.97168 15.8252L6.23047 18.8887V15.5996H3V4H21Z',
      key: '1snbsi',
    },
  ],
  [
    'path',
    {
      d: 'M6 11L14 11',
      key: 'rlhtmw',
    },
  ],
  [
    'path',
    {
      d: 'M6 8L18 8',
      key: '2xtrl0',
    },
  ],
]);
